import React from 'react';
import styled from 'react-emotion';

import BaseListItem from '@material-ui/core/ListItem';
import BaseListItemText from '@material-ui/core/ListItemText';
import BaseListItemAvatar from '@material-ui/core/ListItemAvatar';

import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const ListItem = styled(BaseListItem)`
  display: flex;
  align-items: center;
  padding: ${theme.spacing.small} 0;
  display: flex;
  align-items: center;
`;

export const SetListItem = styled(BaseListItem)`
  padding: 0px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
`;

export const ListItemText = styled(({ isEmail, ...props }) => (
  <BaseListItemText
    {...props}
    classes={{ primary: 'primary', secondary: 'secondary' }}
  />
))`
  padding-left: 12px;
  flex: none;
  flex-basis: 35%;
  .primary {
    color: ${(props) =>
      props.isEmail ? colors.designSystem.blackOpacity60 : colors.black};
    font-family: ${theme.font.family.workSans};
    font-weight: normal;
    font-size: ${theme.font.size.copy};
    line-height: ${theme.font.lineHeight.copy};
  }
  .secondary {
    color: ${colors.designSystem.marker};
    font-family: ${theme.font.family.workSans};
    font-weight: normal;
    ${theme.font.size.small};
    line-height: 16px;
  }
`;

export const ListItemAvatar = styled(BaseListItemAvatar)`
  margin: 0;
`;

export const ListItemIcon = styled(({ IconType, ...props }) => (
  <IconType {...props} />
))`
  font-size: ${theme.font.size.copy};
  color: ${colors.grey11};
`;

export const LockedMessage = styled('div')`
  background: ${colors.bgOrange};
  border-radius: 4px;
  font-weight: 500;

  color: ${colors.orange};
  font-size: 12px;

  padding: 12px;
  margin: 12px;
`;
